import styles from "./bottomGradient.module.scss";

interface BottomGradientProps {
  className?: string;
}

export function BottomGradient({ className }: BottomGradientProps) {
  return (
    <div
      className={`${styles.gradient}${className ? ` ${className}` : ""}`}
    />
  );
}

